import { ReviewsIoDataLoader } from 'reviews-io-data-loader';
if (!window.customElements.get('reviews-io-grid')) {
	class ReviewsIoGrid extends HTMLElement {
		async connectedCallback() {
			if (this._isInitialized) return;
			this._isInitialized = true;

			const hiddenIds = this.hiddenReviews.map((id) => id.trim());
			const selectedIds = this.selectedReviews;
			const renderedIds = new Set();

			const renderAvailable = () => {
				if (renderedIds.size >= this.reviewsCount) return;
				let reviews = this.reviewsIoDataLoader.uniqueFetchedData;
				if (selectedIds.length) {
					reviews = selectedIds.map((id) => reviews.find((r) => r.id === id)).filter(Boolean);
				} else {
					reviews = reviews.filter((reviewItem) => !hiddenIds.includes(reviewItem.id));
				}
				reviews.slice(0, this.reviewsCount).forEach((reviewItem) => {
					if (renderedIds.has(reviewItem.id)) return;
					renderedIds.add(reviewItem.id);
					const card = document.createElement('review-card');
					card.render({
						id: reviewItem.id || '',
						image: reviewItem.photos?.[0] || '',
						rating: reviewItem.rating || 0,
						text: reviewItem.comments || '',
						name: reviewItem?.author?.name || '',
						verified: !!reviewItem.verified || false,
					});
					this.appendChild(card);
				});
			};

			this.reviewsIoDataLoader = new ReviewsIoDataLoader(this.storeID, this.sku);
			await this.reviewsIoDataLoader.startLoading({
				totalCount: this.reviewsCount,
				minRating: this.minRating,
				withFilter: this.withFilter,
				timeOut: 1000,
				onBatch: renderAvailable,
			});
			this.dispatchEvent(new CustomEvent('reviews-io:rendered', { bubbles: true }));
		}
		get storeID() {
			return this.getAttribute('store-id');
		}
		get sku() {
			return this.getAttribute('sku');
		}
		get reviewsCount() {
			return parseInt(this.getAttribute('reviews-count'));
		}
		get minRating() {
			return parseInt(this.getAttribute('min-rating'));
		}
		get withFilter() {
			return this.getAttribute('with-filter');
		}
		get hiddenReviews() {
			const attr = this.getAttribute('hidden-reviews');
			return attr ? attr.split(',') : [];
		}

		get selectedReviews() {
			const attr = this.getAttribute('selected-reviews');
			return attr ? attr.split(',').map((id) => id.trim()) : [];
		}
	}
	window.customElements.define('reviews-io-grid', ReviewsIoGrid);
}
